import app from 'flarum/forum/app';
import { extend } from 'flarum/extend';

import DiscussionListItem from 'flarum/components/DiscussionListItem';

function matchClass(className) {
    // trim() to handle classNames that end with spaces easier
    return node => node && node.attrs && node.attrs.className && node.attrs.className.trim().match(className);
}

app.initializers.add('monsternone/red-title', () => {
    extend(DiscussionListItem.prototype, 'view', function (vnode) {
        const tags = this.attrs.discussion.tags();

        if (tags && tags.length) {
          if (tags[0].slug() == 'ads') {
            try {
                const title = vnode.children.find(matchClass('DiscussionListItem-content Slidable-content'))
                  .children.find(matchClass('DiscussionListItem-main'))
                  .children.find(matchClass('DiscussionListItem-title'));
            title.attrs.className += ' DiscussionListItem-title-red'
}catch(e) {console.log(e)}
          }
        }
      });
});
